// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'
import { Field } from 'redux-form'
import { LabeledInput } from 'components/Form'

const wrapperClasses = (
  'path-db-search-section-sites path-db-search-section display-flex flex-wrap-wrap'
)

const Sites = ({ idRoot }) => (
  <ul className={wrapperClasses}>
    <li className={'path-db-search-input-column'}>
      <Field
        autoFocus={true}
        component={LabeledInput}
        id={`${idRoot}site1-site-name`}
        label={'Site 1'}
        name={'site1-siteName'}
        placeholder={'site name'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}site2-site-name`}
        label={'Site 2'}
        name={'site2-siteName'}
        placeholder={'site name'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}site1-call-sign`}
        label={'Call Sign 1'}
        name={'site1-callSign'}
        placeholder={'call sign'} />
    </li>
    <li className={'path-db-search-input-column'}>
      <Field
        component={LabeledInput}
        id={`${idRoot}site2-call-sign`}
        label={'Call Sign 2'}
        name={'site2-callSign'}
        placeholder={'call sign'} />
    </li>
  </ul>
)

Sites.propTypes = {
  idRoot: string.isRequired,
}

export default Sites
